import { Button, Dialog, DialogActions, DialogContent, useMediaQuery } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { createBoard } from "../api/boardManage";
import { useThemeImage } from "../hooks/useThemeImage";
import CustomerService from "../component/customer_service";
import { useGaEvents } from "../hooks/useGaEvents";
import { useMatomoTrackingPoint } from "../hooks/useMatomoTrackingPoint";
import { AppDispatch, RootState } from "../store";
import { fetchBoardListAsync, setSelectBoardType } from "../store/boardSlice";
import { getUserInfo } from "../util/author";
import { setLocalStorage } from "../util/storage";
import Navigation from "./Manage/navigation";
import gpt2Banner from '../assets/gpt2Banner.png';
import mobileBanner from '../assets/mobileBanner.png';
import gpt2BanerText from '../assets/gpt2BanerText.png'
import {
    setOpenMembershipPurchaseDialogChange
} from "../store/memberSlice";
import Policy from "../component/policy";
import NotificationService from "../component/notification_service";
import { IconButton } from "@mui/material";
import {CollapseIcon} from "../icons";
import MobileNavigation from "./Manage/mobileNavigation";

export default function Manage() {
    const logo = useThemeImage('logo');
    // 首页背景三层叠图（大 logo / 左侧底纹 / 定位底纹）
    const kreneBigLogo = useThemeImage('kreneBigLogo');
    const leftBg = useThemeImage('leftBg');
    const positionBg = useThemeImage('positionBg');
    const navigate = useNavigate();
    const location = useLocation(); // 获取当前路由信息

    const openDialog =  useSelector((state: RootState) => state.board.selectBoardType);

    const { trackWaterdropPackagePopupShow } = useMatomoTrackingPoint();

    const {trackBoardTypeSelect, trackHomeSidebarFold} = useMatomoTrackingPoint()

    const dispatch: AppDispatch = useDispatch();

    const userInfo = getUserInfo()

    const [createLoading, setCreateLoading] = useState(false)

    const { sentOpenCanvasEvent, sentCreateCanvasEvent, sentDeleteCanvasEvent } = useGaEvents();
    const isMobile = useMediaQuery('(max-width: 768px)');

    // 判断当前路由是否包含 "home"
    const showBackground = location.pathname.includes('home');

    const changeBoard = (boardId?: string, query?: string) => {
        sentOpenCanvasEvent({board_id: boardId as string})
        setLocalStorage('boardId', boardId);
        navigate(`/?boardId=${boardId}${query}`);
    }

    const createNewBoard = (boardType: "moodBoard" | "inspireBoard") => {
        if (createLoading) return
        setCreateLoading(true);
        createBoard({boardType}).then(item=>{
            changeBoard(item?.boardId, boardType === 'inspireBoard' ? '&inspire=1' : '')
            setCreateLoading(false)
            dispatch(fetchBoardListAsync())
            sentCreateCanvasEvent({board_id: item?.boardId as string})
            dispatch(setSelectBoardType(false))
            trackBoardTypeSelect({board_id: item?.boardId, board_type: boardType})
        })
    }

    const showNavigate = !isMobile;
    const [collapsed, setCollapsed] = useState(false);

    return (
        <>
            <div style={{
                height: '60px',
                backgroundImage: `url(${isMobile ? mobileBanner : gpt2Banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                textAlign: 'center',
                cursor: 'pointer',
            }} onClick={()=>{
                const page_id = window.location.href;
                trackWaterdropPackagePopupShow({
                    package_show_from: 'homepage_banner',
                    page_id
                });
                if(userInfo) {
                    dispatch(setOpenMembershipPurchaseDialogChange(true))
                }else {
                    const startFreeButton = document.getElementById('startFree');
                    if (startFreeButton) {
                        startFreeButton.click();
                    }
                }
            }}>
                {!isMobile &&
                    <img style={{width: '100%', height: '100%', objectFit: 'contain'}} src={gpt2BanerText} alt=''/>}
            </div>
            <div style={{display: 'flex'}}>
                <CustomerService/>
                <NotificationService />
                <Policy collapsed={collapsed}/>
                {
                    showNavigate ? <div style={{
                        width: collapsed ? 60 : 220,
                        height: 'calc(100vh - 60px)',
                        flexShrink: 0,
                        borderRight: collapsed ? '1px solid var(--c-border)' : 'none',
                        transition: 'width 0.2s ease',
                        overflow: 'hidden',
                        position: 'relative',
                    }}>
                        <IconButton
                            onClick={() => {
                                setCollapsed(prev => {
                                    trackHomeSidebarFold({ page_id: window.location.href, switch_status: prev ? 'expand' : 'fold' });
                                    return !prev;
                                });
                            }}
                            sx={{
                                position: "absolute",
                                top: "18px",
                                left: collapsed ? "10px" : "180px",
                                transition: 'left 0.2s ease',
                                zIndex: 1,
                            }}
                        ><CollapseIcon/></IconButton>
                        {!collapsed && <Navigation/>}
                    </div> : <div style={{
                        position: "absolute",
                        top: "3px",
                        left: "10px",
                        zIndex: 1,
                        display: isMobile ? 'none' : 'block'
                    }}><img src={logo} alt=''/></div>
                }
                <div id='manage-container' style={{
                    width: showNavigate ? (collapsed ? 'calc(100% - 60px)' : 'calc(100% - 220px)') : '100%',
                    height: 'calc(100vh - 60px)',
                    overflow: location.pathname === '/dashboard/home' ? 'hidden' : 'auto',
                    // 只有当路由包含 "home" 时才显示背景图
                    backgroundImage: showBackground ? `url(${kreneBigLogo}), url(${leftBg}), url(${positionBg})` : 'none',
                    backgroundRepeat: 'no-repeat, no-repeat,repeat',
                    backgroundSize: 'auto, 100% auto, auto',
                    backgroundPosition: '1% 2%, left top',
                    position: 'relative',
                }}>
                    {
                        showBackground && <div className='pc-only' style={{
                            position: 'fixed',
                            fontSize: 12,
                            color: 'var(--c-text-weak)',
                            width: "260px",
                            left: 'calc(220px + 4%)',
                            top: '240px',
                            lineHeight: "20px",
                            display: 'none'
                        }}>
                            I went to the woods<br/>
                            because I wished to live deliberately,<br/>
                            to front only the essential facts of life,<br/>
                            and see if I could not learn what it had to teach,<br/>
                            and not, when I came to die,<br/>
                            discover that I had not lived.<br/>
                        </div>
                    }
                    <Outlet/>
                </div>

                {userInfo && <div className="mobile-nav-wrapper"><MobileNavigation/></div>}

                <Dialog
                    open={openDialog}
                    maxWidth="sm"
                    onClose={() => {
                        dispatch(setSelectBoardType(false))
                    }}
                    fullWidth
                    PaperProps={{
                        style: {
                            borderRadius: '20px',
                            padding: '20px'
                        }
                    }}
                >
                    <DialogContent style={{textAlign: 'center', padding: '40px 20px'}}>
                        <div style={{fontSize: '24px', fontWeight: 'bold', color: 'var(--c-text-primary)', marginBottom: '10px'}}>
                            欢迎使用 Krene AI
                        </div>
                        <div style={{fontSize: '16px', color: 'var(--c-text-tertiary)', marginBottom: '30px'}}>
                            请选择您要创建的绘板类型
                        </div>

                        <div style={{display: 'flex', justifyContent: 'center', gap: '20px', marginTop: '20px'}}>
                            <Button
                                onClick={() => {
                                    createNewBoard('inspireBoard')
                                }}
                                variant="outlined"
                                style={{
                                    width: '180px',
                                    height: '180px',
                                    borderRadius: '16px',
                                    flexDirection: 'column',
                                    textTransform: 'none',
                                    borderColor: 'var(--c-violet)',
                                    color: 'var(--c-violet)',
                                    borderWidth: '2px'
                                }}
                            >
                                <div style={{fontSize: '48px', marginBottom: '10px'}}>🖼️</div>
                                <div style={{fontSize: '18px', fontWeight: 'bold'}}>故事绘板</div>
                                <div style={{fontSize: '14px', marginTop: '5px'}}>【推荐】搭建你的专属角色与世界</div>
                            </Button>

                            <Button
                                onClick={() => {
                                    createNewBoard('moodBoard')
                                }}
                                variant="outlined"
                                style={{
                                    width: '180px',
                                    height: '180px',
                                    borderRadius: '16px',
                                    flexDirection: 'column',
                                    textTransform: 'none',
                                    borderColor: 'var(--c-accent)',
                                    color: 'var(--c-accent)',
                                    borderWidth: '2px'
                                }}
                            >
                                <div style={{fontSize: '48px', marginBottom: '10px'}}>🎨</div>
                                <div style={{fontSize: '18px', fontWeight: 'bold'}}>探索绘板</div>
                                <div style={{fontSize: '14px', marginTop: '5px'}}>仅图，相关功能将逐步整合至‘故事绘板’
                                </div>
                            </Button>
                        </div>
                    </DialogContent>

                    <DialogActions style={{justifyContent: 'center', padding: '20px'}}>
                        <Button
                            onClick={() => {
                                dispatch(setSelectBoardType(false))
                            }}
                            style={{textTransform: 'none', color: 'var(--c-text-secondary)'}}
                        >
                            关闭
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </>
    );
}